import { ViewGamePlayer } from './view-game-player'
import { ViewGameStatus } from '../types/view-game.status'
import { GameSettings, gameSettingsNull } from './game.settings'

interface ViewGameProps {
  readonly gameShortId: string
  readonly viewGameStatus: ViewGameStatus
  readonly gameSettings: GameSettings
  readonly players: ViewGamePlayer[]
  readonly createdAt: Date
}

export class ViewGame {
  public readonly gameShortId = this.props.gameShortId
  public readonly viewGameStatus = this.props.viewGameStatus
  public readonly gameSettings = this.props.gameSettings

  public readonly players = this.props.players.map(
    (player) => new ViewGamePlayer(player),
  )

  public readonly createdAt = this.props.createdAt
  public readonly creator = this.players.find((player) => player.isCreator)!

  public readonly leftPlayer = this.players.find(
    (player) => player.isLeftPlayer,
  )!

  public readonly rightPlayer = this.players.find(
    (player) => player.isRightPlayer,
  )!

  constructor(private props: ViewGameProps) {}

  public shouldShowSitAtGame(
    player: ViewGamePlayer,
    signedInPlayerUsername: string,
    isUserSittingAtGame: boolean,
  ): boolean {
    if (isUserSittingAtGame) {
      return false
    }

    if (player.isInvited) {
      return false
    }

    const signedInPlayer = this.players.find(
      (player) => player.username === signedInPlayerUsername,
    )

    if (signedInPlayer && signedInPlayer.isInvited) {
      return false
    }

    if (signedInPlayer && signedInPlayer.isCreator) {
      return false
    }

    if (signedInPlayer && signedInPlayer.isSitting) {
      return false
    }

    return !player.isSitting
  }

  public shouldShowAcceptInvite(
    player: ViewGamePlayer,
    signedInPlayerUsername: string,
    isUserSittingAtGame: boolean,
  ): boolean {
    if (isUserSittingAtGame) {
      return false
    }

    if (player.isSitting) {
      return false
    }

    if (!player.isInvited) {
      return false
    }

    const signedInPlayer = this.players.find(
      (player) => player.username === signedInPlayerUsername,
    )

    return !!signedInPlayer && signedInPlayer.isInvited
  }

  public shouldShowCancelGame(signedInPlayerUsername: string): boolean {
    return this.creator.username === signedInPlayerUsername
  }

  public shouldShowLeaveGame(
    player: ViewGamePlayer,
    signedInPlayerUsername: string,
  ): boolean {
    return (
      signedInPlayerUsername === player.username &&
      player.isSitting &&
      this.viewGameStatus != 'InProgress'
    )
  }

  public shouldShowDisplayName(
    player: ViewGamePlayer,
    signedInPlayerUsername: string,
  ): boolean {
    if (!player.isSitting) {
      return false
    }

    if (this.viewGameStatus == 'InProgress') {
      return true
    }

    return player.username !== signedInPlayerUsername
  }

  public shouldShowIsInvited(
    player: ViewGamePlayer,
    signedInPlayerUsername: string,
  ): boolean {
    if (!player.isInvited) {
      return false
    }

    if (player.isSitting) {
      return false
    }

    return player.username !== signedInPlayerUsername
  }
}

export const viewGameNull: ViewGame = new ViewGame({
  gameShortId: '',
  viewGameStatus: 'Waiting',
  gameSettings: gameSettingsNull,
  players: [],
  createdAt: new Date(),
})
